import { render, staticRenderFns } from "./UpdateIcon.vue?vue&type=template&id=35a1b13f"
import script from "./UpdateIcon.vue?vue&type=script&lang=js"
export * from "./UpdateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports